// Gestión de operadores del negocio (módulo core users_admin, backend /api/biz/users de
// lealify-base). Port de letsmove features/users/api.ts (2026-07-04) — mismo contrato cross
// que usan la agenda dental y Let's Move.
import { baseApi } from './baseClient';

export type UserRole = 'owner' | 'manager' | 'staff';

export interface Operator {
  id: number;
  role: UserRole;
  name: string;
  email: string | null;
  phone: string | null;
  is_active: number;
  created_at: string;
  branch_ids: number[];
  has_password: number; // 1 = ya activó (tiene contraseña); 0 = invitación pendiente
}

export const listOperators = (): Promise<{ users: Operator[] }> => baseApi.get('/biz/users');

// Alta por invitación: manda correo brandeado para que la persona fije su contraseña.
// branch_ids (10-oct-2026): sucursales a las que queda limitado; vacío = todas.
export const inviteOperator = (p: { name: string; email: string; role: UserRole; branch_ids?: number[] }): Promise<{ id: number; invited: boolean }> =>
  baseApi.post('/biz/users', { ...p, invite: true });

export const patchOperator = (id: number, patch: Partial<Pick<Operator, 'name' | 'is_active' | 'role' | 'phone' | 'branch_ids'>>): Promise<{ ok: true }> =>
  baseApi.patch(`/biz/users/${id}`, patch);

export const resendInvite = (id: number): Promise<{ ok: true }> => baseApi.post(`/biz/users/${id}/send-invite`, {});
export const sendReset = (id: number): Promise<{ ok: true }> => baseApi.post(`/biz/users/${id}/send-reset`, {});

// ── Permisos por usuario (user_module_override; solo owner = nivel manage) ──
export type PermLevel = 'none' | 'view' | 'operate' | 'manage';

export interface ModulePermission {
  key: string;
  name: string;
  kind: 'core' | 'cross' | 'vertical';
  inherited: PermLevel;          // lo que le da su rol
  override: PermLevel | null;    // ajuste personal (null = hereda)
  effective: PermLevel;
}

export const getPermissions = (id: number): Promise<{ user: { id: number; name: string; role: UserRole }; modules: ModulePermission[] }> =>
  baseApi.get(`/biz/users/${id}/permissions`);

export const savePermissions = (id: number, overrides: Record<string, PermLevel | null>): Promise<{ ok: true }> =>
  baseApi.put(`/biz/users/${id}/permissions`, { overrides });

// ── "Ver como" (impersonación; solo owner, nunca sobre otro owner) ──
// El backend cambia la cookie de sesión → tras el ok hay que recargar la app completa.
export const impersonate = (id: number): Promise<{ ok: true; viewing: { id: number; name: string; role: UserRole } }> =>
  baseApi.post(`/biz/users/${id}/impersonate`, {});
